import { render, staticRenderFns } from "./content-page-add.vue?vue&type=template&id=802f981a&"
import script from "./content-page-add.vue?vue&type=script&lang=js&"
export * from "./content-page-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports